<ng-container *ngIf="viewMode === 'grid'; else listView">
    <div class="flex flex-col" [class]="parentClass">
        <!-- Grid Content -->
        <ng-container *ngIf="itemsLoading; else gridContent">
            <!-- Grid Skeleton Loading -->
            <div class="flex-1 min-h-0 overflow-y-auto">
                <div [class]="gridClasses">
                    @for(i of [].constructor(rows); track $index) {
                    <p-skeleton width="100%" height="13rem" class="rounded-base"></p-skeleton>
                    }
                </div>
            </div>
        </ng-container>

        <ng-template #gridContent>
            <!-- data-grid handles its own scrolling and pagination layout -->
            <div class="flex-1 min-h-0 overflow-hidden">
                <app-data-grid [items]="items" [columns]="gridColumnsConfig" [gap]="gridGap"
                    [customGridClass]="customGridClass" [pagination]="showPaginator" [rows]="rows"
                    [first]="internalFirst" [totalRecords]="totalRecords" [rowsPerPageOptions]="rowsPerPageOptions"
                    [lazy]="true" (pageChange)="onPageChange($event)">
                    <ng-template #itemTemplate let-item>
                        <ng-container *ngTemplateOutlet="gridItemTemplate; context: { $implicit: item }"></ng-container>
                    </ng-template>
                </app-data-grid>
            </div>
        </ng-template>
    </div>
</ng-container>

<ng-template #listView>
    <div class="list-container flex flex-col" [class]="parentClass">
        <!-- Action Bar Template -->
        <ng-container *ngIf="actionBarTemplate && selectedItems && selectedItems.length > 0 && !itemsLoading">
            <div class="flex-shrink-0 pb-2">
                <ng-container *ngTemplateOutlet="actionBarTemplate"></ng-container>
            </div>
        </ng-container>

        <!-- Loading State for List View -->
        <ng-container *ngIf="itemsLoading; else listContent">
            <div class="flex-1 min-h-0 flex flex-col gap-2">
                @for(i of [].constructor(rows); track $index) {
                <p-skeleton width="100%" height="60px"></p-skeleton>
                }
            </div>
        </ng-container>

        <ng-template #listContent>
            <!-- Data Table or Traditional List View -->
            <ng-container *ngIf="useDataTable; else traditionalList">
                <div class="flex-1 min-h-0 flex flex-col">
                    <div class="flex-1 min-h-0 ">
                        <app-data-table [data]="items" [columns]="tableColumns" [config]="tableConfigWithPagination"
                            [dataKey]="dataKey" [customTemplates]="customTemplates" [tableClass]="tableClasses"
                            [externalPagination]="shouldShowPaginator" [externalFirst]="internalFirst"
                            [externalTotalRecords]="totalRecords" [rowClass]="rowClass"
                            (selectionChange)="onSelectionChange($event)" (pageChange)="onPageChange($event)"
                            (rowClick)="onRowClick($event)">
                        </app-data-table>
                    </div>
                </div>
            </ng-container>

            <ng-template #traditionalList>
                <div class="flex-1 min-h-0 flex flex-col">
                    <!-- List Content -->
                    <div class="flex-1 min-h-0 overflow-y-auto">
                        <div class="w-full">
                            <ng-container *ngTemplateOutlet="listHeaderTemplate"></ng-container>
                            <div class="divide-y divide-gray-200">
                                <ng-container *ngFor="let item of items">
                                    <ng-container
                                        *ngTemplateOutlet="listRowTemplate; context: { $implicit: item }"></ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <!-- Traditional List Paginator (Keep for traditional list view) -->
                    @if(shouldShowPaginator) {
                    <div class="mt-auto paginator-container">
                        <p-paginator [rows]="rows" [totalRecords]="totalRecords"
                            [rowsPerPageOptions]="rowsPerPageOptions" [first]="internalFirst"
                            (onPageChange)="onPageChange($event)">
                        </p-paginator>
                    </div>
                    }
                </div>
            </ng-template>
        </ng-template>
    </div>
</ng-template>